import { THEMES } from '../../../utils/cms-utils';
import ThemeContainer from '../../../components/theme-container/ThemeContainer';
import TrackEventLink from '../../../components/track-event-link/TrackEventLink';
import { useSelector } from 'react-redux';
import styles from './vm2025-event-banner.module.less';
import Image from '../../../components/image/Image';

export const VM2025EventBanner = () => {
    const baseUrl = useSelector((state) => state.baseURL);
    return (
        <ThemeContainer mainColor={THEMES.SYRIN30} className={styles.banner}>
            <Image src={'campaign/vm2025/skilue.svg'} alt={'Skilue'} className={styles.logo} />
            <div>
                <p className={styles.text}>
                    Dugnaden er en del av VM-Dugnad i forbindelse med Ski-VM.
                    Klubben&nbsp;får&nbsp;70&nbsp;%&nbsp;fortjeneste&nbsp;av&nbsp;salget.
                </p>
                <TrackEventLink
                    to={`${baseUrl}/vm-dugnad`}
                    target={'_blank'}
                    category={'project_banner_vm2025'}
                    action={'link_click'}
                >
                    Les mer om VM-dugnad
                </TrackEventLink>
            </div>
        </ThemeContainer>
    );
};
